import { useParams } from 'react-router-dom';
import { MdOutlineSearch } from 'react-icons/md';

import { OMultiDropdown } from '@src/components';
import CountryBadge from '@src/components/CountryBadge';

import { OButton, ODropdownSplitButton } from '@src/shared';

import { useAttendeesFilter } from '../useAttendeesFilter';
import styles from '../attendeesFilter.module.scss';

import { IAttendeesFiltersProps } from '@src/types';

const AttendeesFiltersWeb = ({
  filters,
  SelectAll,
  UnselectAll,
  selectedAttendees,
  handleOpenBulkActionModal,
  handleFilterChange,
}: IAttendeesFiltersProps) => {
  const { id } = useParams();

  const { countries, typeOptions, companyOptions, emailDomainOptions, searchValue, handleSearchChange } =
    useAttendeesFilter(id);

  return (
    <div className={styles.container}>
      <div className={styles.filtersContainer}>
        <OMultiDropdown
          label="Type"
          options={typeOptions}
          value={filters.types}
          onChange={(val) => handleFilterChange('types', val)}
          getOptionLabel={(opt) => opt.label}
        />

        <OMultiDropdown
          label="Email Domain"
          options={emailDomainOptions}
          value={filters.emailDomains}
          onChange={(val) => handleFilterChange('emailDomains', val)}
          getOptionLabel={(opt) => opt.label}
        />

        <OMultiDropdown
          label="Country"
          options={countries}
          value={filters.countries}
          onChange={(val) => handleFilterChange('countries', val)}
          renderOption={(c) => <CountryBadge countryCode={c.code} countryName={c.label} />}
          getOptionLabel={(opt) => opt.label}
        />

        <OMultiDropdown
          label="Company"
          options={companyOptions}
          value={filters.companies}
          onChange={(val) => handleFilterChange('companies', val)}
          getOptionLabel={(opt) => opt.label}
        />
      </div>

      <div className="flex gap-4">
        <div className="flex justify-center">
          {selectedAttendees.length ? (
            <ODropdownSplitButton
              text={`Un-Select all (${selectedAttendees.length})`}
              onClick={UnselectAll}
              dropdownModel={[
                {
                  label: 'Approve',
                  command: () => {
                    handleOpenBulkActionModal(true, true);
                  },
                },
                {
                  label: 'Reject',
                  command: () => {
                    handleOpenBulkActionModal(true, false);
                  },
                },
              ]}
              size="large"
            />
          ) : (
            <OButton
              text="Select all"
              variant="primary"
              size="medium"
              outlined
              onClick={() => {
                SelectAll();
              }}
            />
          )}
        </div>

        <div className="relative mr-4">
          <div className="absolute top-1/2 -translate-y-1/2 left-2">
            <MdOutlineSearch className="text-gray-500 text-xl" />
          </div>
          <input
            type="text"
            placeholder="Search by name or email"
            value={searchValue}
            onChange={handleSearchChange}
            className={styles.searchInput}
          />
        </div>
      </div>
    </div>
  );
};

export default AttendeesFiltersWeb;
